export let FORM_ERROR_TYPES;
(function (FORM_ERROR_TYPES) {
  FORM_ERROR_TYPES["EMPTY"] = "empty";
  FORM_ERROR_TYPES["INVALID_FORMAT"] = "invalidFormat";
  FORM_ERROR_TYPES["NO_MATCH"] = "noMatch";
  FORM_ERROR_TYPES["NO_ERROR"] = "noError";
})(FORM_ERROR_TYPES || (FORM_ERROR_TYPES = {}));
export const HS_CUSTOM_DOMAIN_PREFIX = '/hs/email-subscriptions';
export const DEFAULT_LANGUAGE = 'en';
export const UNSUBSCRIBE_MODE = {
  ALL: 'ALL',
  SINGLE: 'SINGLE'
};